import React, { useEffect, useRef } from 'react';

const About = () => {
  const skillBarsRef = useRef([]);

  useEffect(() => {
    // Force section to be visible immediately
    const section = document.getElementById('about');
    if (section) {
      section.style.opacity = '1';
      section.classList.add('animate');
    }
    
    // Animate skill bars without waiting for intersection
    setTimeout(() => {
      skillBarsRef.current.forEach(bar => {
        if (bar) {
          const width = bar.style.width;
          bar.style.width = width;
        }
      });
    }, 500);
    
  }, []);

  return (
    <section id="about" className="section about">
      <h1 className="title">About Me</h1>
      <div className="about-content">
        <div className="about-text">
          <p>I'm a professional with expertise in IT and IoT project management. With a background in systems management and application development, I bring a unique perspective to technology projects.</p>
          <p>My approach combines technical knowledge with project management methodologies to deliver efficient and effective solutions.</p>
        </div>
        <div className="skills">
          <h2>Skills</h2>
          <div className="skill-progress">
            <div className="skill">
              <span className="skill-name">JavaScript</span>
              <div className="progress-container">
                <div 
                  className="progress-bar" 
                  style={{ width: '90%' }}
                  ref={el => el && skillBarsRef.current.push(el)}
                ></div>
              </div>
              <span className="skill-percentage">90%</span>
            </div>
            <div className="skill">
              <span className="skill-name">Lua</span>
              <div className="progress-container">
                <div 
                  className="progress-bar" 
                  style={{ width: '95%' }}
                  ref={el => el && skillBarsRef.current.push(el)}
                ></div>
              </div>
              <span className="skill-percentage">95%</span>
            </div>
            <div className="skill">
              <span className="skill-name">HTML/CSS</span>
              <div className="progress-container">
                <div 
                  className="progress-bar" 
                  style={{ width: '85%' }}
                  ref={el => el && skillBarsRef.current.push(el)}
                ></div>
              </div>
              <span className="skill-percentage">85%</span>
            </div>
            <div className="skill">
              <span className="skill-name">React</span>
              <div className="progress-container">
                <div 
                  className="progress-bar" 
                  style={{ width: '75%' }}
                  ref={el => el && skillBarsRef.current.push(el)}
                ></div>
              </div>
              <span className="skill-percentage">75%</span>
            </div>
            <div className="skill">
              <span className="skill-name">Project Management</span>
              <div className="progress-container">
                <div 
                  className="progress-bar" 
                  style={{ width: '88%' }}
                  ref={el => el && skillBarsRef.current.push(el)}
                ></div>
              </div>
              <span className="skill-percentage">88%</span>
            </div>
          </div>
          <div className="skill-tags">
            <span className="skill-tag">IoT</span>
            <span className="skill-tag">System Administration</span>
            <span className="skill-tag">Node.js</span>
            <span className="skill-tag">Git</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 